import { useState } from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import './DropZone.less';
export interface IDropZone {
  options: DropzoneOptions;
  disabled?: boolean;
  message?: string;
}

export const DropZone: React.FC<IDropZone> = ({
	options,
	children,
	disabled,
	message
}) => {
	const [errorMessages] = useState([]);
	const { getRootProps, getInputProps, isDragActive } = useDropzone(options);
	const hasErrors = errorMessages.length > 0;
	const hasContentStyle = !disabled && children ? ' hascontent' : '';
	const hasMessageStyle =
		!disabled && message && !isDragActive ? ' hasmessage' : '';
	const activeStyle = isDragActive ? ' isactive' : '';
	const hasErrorStyle = hasErrors ? ' haserrors' : '';
	const messageBoxStyle =
		'messagebox' +
		hasContentStyle +
		hasMessageStyle +
		activeStyle +
		hasErrorStyle;

	return (
		<div className={`container displayhack${disabled ? ' disabled' : ''}`}>
			<div className={messageBoxStyle}>
				{errorMessages.length > 0 ? (
					<>
						<p>Selected CSV file is invalid, please try again:</p>
						<ul style={{ paddingLeft: '1em' }}>
							{errorMessages.map((message, i) => (
								<li key={'error_' + i}>{message}</li>
							))}
						</ul>
					</>
				) : (
					<>
						{!disabled && !children && !message && (
							<div>Click or drag and drop the CSV files here</div>
						)}
						{!disabled && isDragActive && children && (
							<div>Drop to add</div>
						)}
						{!disabled && !isDragActive && message && <div>{message}</div>}
						{disabled && <div>{disabled || 'File select is disabled'}</div>}
					</>
				)}
			</div>
			{children ? (
				<div>
					{children}
					<div {...getRootProps()} className={`dropzone addmore`}>
						<input {...getInputProps()} />
						<div>Click here or drag and drop the CSV files to add more</div>
					</div>	
				</div>
			) : (
				<div {...getRootProps()} className={`childrenwrapper dropzone`}>
					<input {...getInputProps()} />
				</div>
			)}
		</div>
	);
};

